import React from 'react';

import { useFeatureFlags } from '@ApplicationWide/feature-flags';
import { ACCOUNT_SETTINGS_PATH } from '@ApplicationWide/constants/routes';
import { filterRoutes } from '@ApplicationWide/routes/routeUtils';
import { PREVIEW_NEW_HIRE_EXPERIENCE_PATH } from './non-admin-urls';

import HOME_ROUTE from './homeRoute';
import COMPANY_ROUTE from './companyRoute';
import PEOPLE_ROUTE from './peopleRoute';
import ORG_CHART_ROUTE from './orgChartRoute';
import ORG_CHART_PAYWALL_ROUTE from './orgChartPaywallRoute';
import ACTIVITIES_COMPLETED_ROUTE from './activitiesCompletedRoute';

const PersonalSettingsPage = React.lazy(() => import('../../../pages/PersonalSettings/PersonalSettingsPage'));
const PreboardingPage = React.lazy(() => import('../../../pages/PreboardingPage'));
const ResetPasswordPage = React.lazy(() => import('../../../pages/Auth/ResetPasswordPage'));
const WorkspacePage = React.lazy(() => import('../../../pages/WorkspacePage'));
const UserRequestedInformationForm = React.lazy(() =>
  import('../../../pages/UserRequestedInformationPage/UserRequestedInformationForm'),
);

const nonAdminRoutesInNavBar = [
  {
    ...HOME_ROUTE,
    orderInGroup: 10,
  },
  {
    ...COMPANY_ROUTE,
    orderInGroup: 10,
  },
  {
    ...PEOPLE_ROUTE,
    orderInGroup: 20,
  },
  {
    ...ORG_CHART_ROUTE,
    orderInGroup: 30,
  },
  {
    ...ORG_CHART_PAYWALL_ROUTE,
    orderInGroup: 30,
  },
  {
    ...ACTIVITIES_COMPLETED_ROUTE,
    orderInGroup: 10,
  },
];

const nonAdminRoutes = [
  ...nonAdminRoutesInNavBar,
  {
    to: '/reset_password',
    route: '/reset_password',
    component: ResetPasswordPage,
  },
  {
    to: ACCOUNT_SETTINGS_PATH,
    route: ACCOUNT_SETTINGS_PATH,
    component: PersonalSettingsPage,
    hasNavBar: true,
  },
  {
    to: '/preboarding/:stepId?',
    route: ['/preboarding/:stepId?', PREVIEW_NEW_HIRE_EXPERIENCE_PATH],
    component: PreboardingPage,
  },
  {
    to: '/workspace/:workspaceId/:tabId',
    route: '/workspace/:workspaceId/:tabId',
    component: WorkspacePage,
    hasNavBar: true,
  },
  {
    to: '/requested_information/:requested_info_id',
    route: ['/requested_information/:requested_info_id'],
    component: UserRequestedInformationForm,
  },
];

export const useAvailableNonAdminNavBarRoutes = () => {
  const featureFlags = useFeatureFlags();
  return filterRoutes(nonAdminRoutesInNavBar, featureFlags);
};

export const useAvailableNonAdminRoutes = () => {
  const featureFlags = useFeatureFlags();
  return filterRoutes(nonAdminRoutes, featureFlags);
};
